import { OrderDetailType } from "../../slices/my-account/Types"

export const myAccountSagaActionType = {
    callContractFindAllSaga: "callContractFindAllSaga",
    callAllOrdersSaga: "callAllOrdersSaga",
    callOrderDetailSaga: 'callOrderDetailSaga',
    callUpdateContractSaga : 'callUpdateContractSaga',
    callfetchCustomerDetailSaga: 'callfetchCustomerDetailSaga',
    callOrderDetailPDFSaga: 'callOrderDetailPDFSaga',
    callUpdateCustomerSaga: 'callUpdateCustomerSaga',
    callActivateBoldSubscriptionSaga: 'callActivateBoldSubscriptionSaga',
    callPauseBoldSubscriptionSaga: 'callPauseBoldSubscriptionSaga'
}


export const contractFindAllSagaAction : (ID: number) => {
    type: string,
    payload : {
        ID : number
    }
} = (ID) => {
    return {
        type: myAccountSagaActionType.callContractFindAllSaga,
        payload : {
            ID : ID
        }
    }
}

export const allOrdersSagaAction: (ID: number) => {
    type: string,
    payload : {
        ID : number
    }
} = (ID) => {
    return {
        type: myAccountSagaActionType.callAllOrdersSaga,
        payload : {
            ID : ID
        }
    }
}

// export const fetchCustomerDetailSagaAction: () => {
//     type: string,
// } = () => {
//     return {
//         type: myAccountSagaActionType.callfetchCustomerDetailSaga,
//     }
// }

export type updateContractSagaActionPayloadType = {
    ID: number;
    partnerID: number
    startDate : string; 
    endDate : string;
    salesforce_opportunity: string;
    oracle_channel: number | null;
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
export const updateContractSagaAction : (payload: updateContractSagaActionPayloadType) => {
    type: string,
    payload: updateContractSagaActionPayloadType
} = (payload) => {
    return {
        type : myAccountSagaActionType.callUpdateContractSaga,
        payload: payload
    }
}

export const orderDetailSagaAction : (orderId : string) => {
    type: string,
    payload: {
        orderId: string
    }
} = (orderId) => {
    return {
        type: myAccountSagaActionType.callOrderDetailSaga,
        payload: {
            orderId: orderId
        }
    }
}

type orderDetailPDFSagaActionPayloadType = {
    orderId: string,
    generatePdfDocumentFunction : (orderDetailPdfData: OrderDetailType) => void
}
export const orderDetailPDFSagaAction : (data : orderDetailPDFSagaActionPayloadType) => {
    type: string,
    payload: orderDetailPDFSagaActionPayloadType
} = (data) => {
    return {
        type: myAccountSagaActionType.callOrderDetailPDFSaga,
        payload: data
    }
}

export const activateBoldSubscriptionSagaAction: (subscriptionId: string) => {
    type: string,
    payload : {
        subscriptionId : string
    }
} = (subscriptionId) => {
    return {
        type: myAccountSagaActionType.callActivateBoldSubscriptionSaga,
        payload : {
            subscriptionId : subscriptionId
        }
    }
}

export const pauseBoldSubscriptionSagaAction: (subscriptionId: string) => {
    type: string,
    payload : {
        subscriptionId : string
    }
} = (subscriptionId) => {
    return {
        type: myAccountSagaActionType.callPauseBoldSubscriptionSaga,
        payload : {
            subscriptionId : subscriptionId
        }
    }
}